import {connect} from 'react-redux'
import {addLeg} from '../leg/leg.action'
import {DayBlock} from './dayblock.component'
import {setCommitMsg} from '../socket/socket.action'


const mapStateToProps = (state) => {
    return {
        arrivalDate: state.getIn(['document', 'properties', 'arrivalDate'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddLeg: (dayIndex, legLength) => {
            dispatch(setCommitMsg('Added new leg'))
            dispatch(addLeg(dayIndex, legLength))
        }
    }
}

const DayBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(DayBlock)

export default DayBlockContainer
